import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ColorSchemeService } from '../../services';

@Component({
  selector: 'un-empty',
  templateUrl: './empty.component.html',
  styleUrls: ['./empty.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EmptyComponent {
  @Input() icon?: string;
  @Input() description?: string;
  @Input() btnLink?: string | string[];
  @Input() btnText?: string;
  @Input() size = 64;

  constructor(public colorScheme: ColorSchemeService) {}
}
